/**
 * BY REP.
 *
 * Four numbers, and the last two are the ones Brian's rule makes necessary.
 *
 *   ASKED     entirely the rep's, and fair to manage on
 *   LANDED    partly the customer's — celebrate it, do not manage on it
 *   MEDIAN LAG   how many days after DELIVERY they asked
 *   AT PEAK   what share of their asks landed inside the window
 *
 * A rep with a strong conversion and a 26-day median is not asking well. They
 * are asking late and getting away with it, and without the lag column that is
 * invisible — which is exactly how a timing rule quietly becomes optional.
 */
import s from './reviews.module.css'

const lagTone = (d) => (d == null ? '' : d <= 7 ? s.ok : d <= 21 ? '' : s.selfReported)

export default function Scoreboard({ data }) {
  const reps = data?.reps || []

  if (!reps.length) {
    return (
      <div className={s.wrap}>
        <div className={s.empty}>
          No asks recorded yet. This board fills the first time somebody records one from
          the queue.
        </div>
      </div>
    )
  }

  return (
    <div className={s.wrap}>
      <table className={s.table}>
        <thead>
          <tr>
            <th>Rep</th>
            <th>Asked</th>
            <th>Landed</th>
            <th>Verified</th>
            <th>Conversion</th>
            <th>Median lag</th>
            <th>At peak</th>
          </tr>
        </thead>
        <tbody>
          {reps.map((r) => (
            /* Declared a readout: review asked / landed / verified counts per
               rep. The destination a rep row WOULD want is their ask queue, and
               wiring one here without checking that it can be scoped by rep is
               how an enabled-but-dead control gets made. Stated, not guessed. */
            <tr key={r.repId} aria-disabled="true">
              <td data-label="Rep"><strong>{r.name || r.repId}</strong></td>
              <td data-label="Asked" className={s.num}>{r.asked}</td>
              <td data-label="Landed" className={s.num}>{r.landed}</td>
              <td data-label="Verified" className={s.num}>{r.verified}</td>
              <td data-label="Conversion" className={s.num}>
                {r.conversion == null ? '—' : `${r.conversion}%`}
              </td>
              <td data-label="Median lag" className={`${s.num} ${lagTone(r.medianAskLagDays)}`}>
                {r.medianAskLagDays == null ? '—' : `${r.medianAskLagDays}d`}
              </td>
              <td data-label="At peak" className={s.num}>
                {r.peakRate == null ? '—' : `${r.peakRate}%`}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className={s.note}>
        <strong>Asked</strong> is the rep’s and fair to manage on. <strong>Landed</strong> is
        partly the customer’s. <strong>Median lag</strong> counts days from delivery to the
        ask, and <strong>at peak</strong> is the share made while the customer was still
        excited — a high conversion with a long lag means the timing is wrong even though
        the outcome looks fine. <strong>Verified</strong> counts only those a second person
        confirmed; anything landed but unverified is self-reported.
      </p>
    </div>
  )
}
